import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { ThingTypeIcon } from "../icons";

export default {
  options: {
    group: "types",
    accessible: ({ user }) =>
      user.role === "admin" &&
      user.permissions.indexOf("thing-type/list") !== -1,
  },
  icon: ThingTypeIcon,
  list: List,
  edit: Edit,
  create: Create,
};
